export { default } from './ChangePasswordForm.container'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Auth/ChangePasswordForm/index.js